import "./../../public/icon-font/style.css";
import { LOCALE } from "@/enums/locale";

import Vue from "vue";
import Vuetify from "vuetify/lib";
import pl from "vuetify/es5/locale/pl";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { pl },
    current: LOCALE.PL
  },
  icons: {
    iconfont: "mdi",
    values: {
      checkboxOff: "icon-checkbox-off",
      checkboxOn: "icon-checkbox-on",
      radioOff: "icon-radio-off",
      radioOn: "icon-radio-on"
    }
  },
  theme: {
    themes: {
      light: {
        blueFb: "#0866FF",
        primary: "#4A24AC",
        secondary: "#F0A801",
        darkGreen: "#2E9265",
        success: "#009688",
        accent: "#DBDA1F",
        info: "#1E88E5",
        error: "#b71c1c",
        "red-1": "#FB1C2C",
        "green-1": "#1BCB11",
        "orange-1": "#FDAA10",
        teal: "#23AAA5",
        "teal-1": "#27C1BC",
        light: "#ffffff",
        pink: "#ff306e",
        text: "#363c56",
        "text-muted": "#9C9FAC",
        "red-2": "#FD5285"
      },
      dark: {
        blueFb: "#0866FF",
        primary: "#4A24AC",
        secondary: "#F0A801",
        darkGreen: "#2E9265",
        success: "#009688",
        accent: "#DBDA1F",
        info: "#1E88E5",
        error: "#b71c1c",
        "red-1": "#FB1C2C",
        "green-1": "#1BCB11",
        "orange-1": "#FDAA10",
        teal: "#23AAA5",
        light: "#ffffff",
        pink: "#ff306e",
        text: "#363c56",
        "text-muted": "#9C9FAC"
      }
    }
  }
});
